import { apiSlice } from './apiSlice';
import { STORESALES_URL } from '../constants';

export const storeSalesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new storeSale
    createStoreSale: builder.mutation({
      query: (storeSale) => ({
        url: STORESALES_URL,
        method: 'POST',
        body: storeSale,
      }),
    }),

    // Get storeSale details by ID
    getStoreSaleDetails: builder.query({
      query: (id) => ({
        url: `${STORESALES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's storeSales
    getMyStoreSales: builder.query({
      query: () => ({
        url: `${STORESALES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all storeSales (Admin)
    getStoreSales: builder.query({
      query: () => ({
        url: STORESALES_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark storeSale as delivered
    deliverStoreSale: builder.mutation({
      query: (storeSaleId) => ({
        url: `${STORESALES_URL}/${storeSaleId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete storeSale
    deleteStoreSale: builder.mutation({
      query: (storeSaleId) => ({
        url: `${STORESALES_URL}/${storeSaleId}`,
        method: 'DELETE',
      }),
    }),

    // Update storeSale (FIXED)
    updateStoreSale: builder.mutation({
      query: ({ storeSaleId, ...body }) => ({
        url: `${STORESALES_URL}/${storeSaleId}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useCreateStoreSaleMutation,
  useGetStoreSaleDetailsQuery,
  useGetMyStoreSalesQuery,
  useGetStoreSalesQuery,
  useDeliverStoreSaleMutation,
  useDeleteStoreSaleMutation,
  useUpdateStoreSaleMutation,
} = storeSalesApiSlice;
